import { Axios } from 'axios'
import { createContext, Dispatch, SetStateAction } from 'react'
import { Branded, RolodexPermissionsUser } from 'types'

import { RolodexPermissions } from './permissions/rolodexPermissionsList'

export type AuthedAxiosRequests = Omit<Axios, 'interceptors' | 'defaults'>

export type GeckoUser = {
  email: string
  name: string
  familyName: string
  givenName: string
  picture: string
}

export type GeckoLogoutParams = {
  returnTo?: string
}

export type GeckoAuthContextType = {
  // Auth
  authorization: string | undefined
  authorizedAxios: AuthedAxiosRequests
  isAuthenticated: boolean
  // User
  currentUser: RolodexPermissionsUser | undefined
  refreshCurrentUser: () => void
  // Permissions
  permissions: ReadonlySet<string> | undefined
  hasPermissions: (permissionsToCheck: RolodexPermissions[]) => boolean
  // User Info
  user: GeckoUser | undefined
  logout: (geckoLogoutParams: GeckoLogoutParams) => void
  // Permission Debugging
  showPermissionGates: boolean
  setShowPermissionGates: Dispatch<SetStateAction<boolean>>
}

/** A context providing useful authentication/authorization information */
export const GeckoAuthContext = createContext<GeckoAuthContextType | undefined>(
  undefined
)

export interface AuthToken {
  token: string
}

/**
 * A UserId from Rolodex
 */
export type UserId = Branded<string, 'UserId'>
